import PropTypes from 'prop-types';
import { usePoliteStatusMessage } from '../hooks';

const PageUpdateHandler = ({ message }) => {
  usePoliteStatusMessage(message);

  return null;
};

PageUpdateHandler.propTypes = {
  message: PropTypes.node,
};

PageUpdateHandler.defaultProps = {
  message: null,
};

export default PageUpdateHandler;
